<app-dialog [(visible)]="visible"
            header="Gérer les permissions" width="620px"
            [dismissableMask]="false" styleClass="user-permissions-dialog">

  @if (user(); as u) {
    <div class="user-summary">
      <div class="user-name">{{ u.firstName }} {{ u.lastName }}</div>
      <div class="user-email">{{ u.email }}</div>
    </div>
  }

  @if (isSuperAdmin) {
    <p class="super-admin-note">
      <i class="pi pi-shield"></i>
      Les super-administrateurs disposent de tous les droits.
    </p>
  } @else if (loading()) {
    <div class="loading-wrap">
      <p-progressSpinner styleClass="spinner-sm" strokeWidth="4" />
    </div>
  } @else {
    <div class="select-all-row">
      <p-checkbox [ngModel]="allGranted" [indeterminate]="allGrantedIndeterminate"
                  [binary]="true" (onChange)="toggleAll($event.checked)" inputId="select-all" />
      <label for="select-all">Tout cocher</label>
    </div>

    <p-accordion [value]="openGroups()" [multiple]="true">
      @for (group of groups(); track group.key) {
        <p-accordion-panel [value]="group.key">
          <p-accordion-header>
            <div class="group-header">
              <p-checkbox [ngModel]="isGroupFullyGranted(group)" [indeterminate]="isGroupIndeterminate(group)"
                          [binary]="true" (onChange)="toggleGroup(group, $event.checked)"
                          (click)="$event.stopPropagation()" />
              <span class="group-label">{{ group.label }}</span>
            </div>
          </p-accordion-header>
          <p-accordion-content>
            <div class="permissions-list">
              @for (perm of group.permissions; track perm.code) {
                <div class="permission-row">
                  <div class="permission-info">
                    <div class="permission-label">{{ perm.label }}</div>
                    <div class="permission-description">{{ perm.description }}</div>
                  </div>
                  <p-toggleswitch [ngModel]="isGranted(perm.code)" (ngModelChange)="toggle(perm.code, $event)" />
                </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
      @if (catalog().length === 0) {
        <p class="empty-note">Aucune permission disponible.</p>
      }
    </p-accordion>
  }

  <div dialogFooter>
    <button pButton [text]="true" (click)="close()" label="Annuler"></button>
    @if (!isSuperAdmin) {
      <button pButton (click)="save()" class="btn-save"
              [disabled]="loading() || saving()" [loading]="saving()"
              icon="pi pi-check" label="Enregistrer"></button>
    }
  </div>
</app-dialog>
